export const socialsData = {
    github: 'https://github.com/mvrque',
    linkedIn: 'www.linkedin.com/in/tomik-marko',
}
